<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/pointsdetails/select"
      :model="formModel"
      buttonName="调账"
      buttonType="warning"
      addShowPower="/pointsdetails/tiaozhang"
      @openAddDialog="openDialog"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      downloadPower="/pointsdetails/PeopleExport"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
      totaltext="/pointsdetails/heji"
      :totalShow="true"
      @totalLookDialog="totalLookDialog()"
      totalName="合计"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商姓名">
        <el-input v-model="formModel.userName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input v-model="formModel.userPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="formModel.orderNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="机具SN号">
        <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.type">
          <el-option
            v-for="item in operationType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作类型">
        <el-select v-model="formModel.operationDirection">
          <el-option
            v-for="item in operationDirection"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="通道积分类型">
        <el-select v-model="formModel.chnType">
          <el-option
            v-for="item in chnType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="代理商姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userPhone"
        label="代理商手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        label="商户名称"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merNo"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merPhone"
        label="商户手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="SN号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="交易类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operationDirection"
        label="操作类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableoperationDirection"
      ></el-table-column>
      <el-table-column
        prop="chnType"
        label="通道积分类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTablechnType"
      ></el-table-column>
      <el-table-column
        prop="number"
        label="积分数量"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="balNumber"
        label="剩余数量"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        fixed="right"
        prop="createTime"
        label="创建时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>积分数量：{{ dialogObj || 0 }}</p>
      </div>
    </show-info-dialog>
    <form-dialog
      ref="formDialog"
      formDialogTitle="调账"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label-width="130px" label="代理商ID" prop="memId">
        <el-input
          type="textarea"
          v-model="dialogModel.memId"
          rows="5"
          placeholder="请输入，多个‘,’分割"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="130px" label="交易类型" prop="operation">
        <el-select v-model="dialogModel.operation">
          <el-option
            placeholder="请选择"
            v-for="item in operationType.slice(1, operationType.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="130px" label="通道积分类型" prop="chnType">
        <el-select v-model="dialogModel.chnType">
          <el-option
            placeholder="请选择"
            v-for="item in chnType.slice(1, chnType.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="130px" label=" " prop="operationDirection">
        <el-radio-group v-model="dialogModel.operationDirection">
          <el-radio :label="1">加</el-radio>
          <el-radio :label="2">减</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label-width="130px" label="积分数量" prop="adjustAmt">
        <el-input-number
          v-model="dialogModel.adjustAmt"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="130px" label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import StatisticsService from "service/StatisticsService";
import TransactionService from "service/TransactionService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "pointsdetails",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
    FormDialog,
  },
  data() {
    return {
      dialogObj: {},
      formModel: {
        userId: "",
        userName: "",
        userPhone: "",
        orderNo: "",
        sn: "",
        type: "",
        time: "",
        operationDirection: "",
        chnType: "",
      },
      dialogModel: {
        memId: "",
        operation: "",
        operationDirection: 1,
        adjustAmt: "",
        chnType: "",
        remark: "",
      },
      dialogRules: {
        operation: [
          {
            required: true,
            message: "请选择",
          },
        ],
        chnType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        adjustAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
        memId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const aa = /^\+?[1-9]\d*$/;
              if (!value) {
                callback(new Error("请输入"));
              } else if (value.split(",").some((item) => !aa.test(item))) {
                callback(new Error("请输入正确的代理商ID"));
              } else {
                return callback();
              }
            },
          },
        ],
      },
      operationType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      chnType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      operationDirection: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "1",
          dictValue: "加",
        },
        {
          dictKey: "2",
          dictValue: "减",
        },
      ],
      tableData: [],
      submitService: TransactionService.pointsdetailsList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getTypeNames("代理商积分类型", (res) => {
      this.operationType = [...this.operationType, ...res];
    });
    this.getTypeNames("通道积分类型", (res) => {
      this.chnType = [...this.chnType, ...res];
    });
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        userId: this.formModel.userId,
        userName: this.formModel.userName,
        userPhone: this.formModel.userPhone,
        orderNo: this.formModel.orderNo,
        sn: this.formModel.sn,
        type: this.formModel.type,
        operationDirection: this.formModel.operationDirection,
        chnType: this.formModel.chnType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        operation: this.dialogModel.operation,
        memId: this.dialogModel.memId,
        operationDirection: this.dialogModel.operationDirection,
        adjustAmt: this.dialogModel.adjustAmt,
        chnType: this.dialogModel.chnType,
        remark: this.dialogModel.remark,
      };
      console.log(params);
      return params;
    },
    dialogService() {
      return TransactionService.pointsdetailsTiaoz;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        type: "",
        time: "",
        operationDirection: "",
        chnType: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openDialog(item) {
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
        memId: "",
        operation: "",
        operationDirection: 1,
        adjustAmt: "",
        chnType: "",
        remark: "",
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8885",
            "/integral/t-integral-dtl/"
          )
        : "";
    },
    totalLookDialog() {
      this.doLoad(
        TransactionService.pointsdetailsheji,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    formatterTableoperationDirection(row, column, cellValue, index) {
      let value = "--";
      this.operationDirection.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTableoperationType(row, column, cellValue, index) {
      let value = "--";
      this.operationType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTablechnType(row, column, cellValue, index) {
      let value = "--";
      this.chnType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/PointsDetails.vue